/**
 * @file 页面侧边导航Menu
 * @author sunyingying01
 */

import React, {useCallback, useState} from 'react';
import {Menu, Popover} from 'antd';
import {observer} from 'mobx-react-lite';
import {useLocation} from 'react-router-dom';

import {Projects, Jobs} from '@/modules/SiderModules';
import {getFirstChar, getAvatarFontSize} from '@/utils';
import UserInfoCard from '../UserInfoCard';
import styles from './index.module.less';

export interface IProps {
    store: IPageStore;
}

const userImgPath = 'https://now.bdstatic.com/stash/v1/84b278a/fm-console-fe/65c99cd/img/whitelist/user.png';
const Menus: React.FC<IProps> = props => {
    const {rootStore} = props.store;
    const {siderNavigationStore, userStore} = rootStore;
    const isSiderCollapsed = siderNavigationStore.collapsed;

    const [userOpen, setUserOpen] = useState<boolean>(false);
    const location = useLocation();

    // 切换菜单
    const handleMenu = useCallback(
        (e: {selectedKeys: string[]}) => {
            siderNavigationStore.setSelectedMenu(e.selectedKeys[0] as MenuKeyType);
        },
        [siderNavigationStore]
    );

    // 菜单展开状态
    const handleOpenChange = useCallback(
        async (val: boolean) => {
            if (val) {
                // Popover 打开前先请求账号计费信息
                await userStore.fetchAccountInfo();
            }
            setUserOpen(val);
        },
        [userStore]
    );

    return (
        <>
            <Menu
                mode="inline"
                className={`${styles.customMenu} ${styles.customMenuWrapper}`}
                onSelect={handleMenu}
                selectedKeys={[]}
            >
                <div className={styles.menuItem}>
                    <Menu.Item key="projects">
                        <Projects store={props.store} />
                    </Menu.Item>
                </div>
                <Jobs store={props.store} />
            </Menu>

            <div className={styles.bottomSection}>
                <Menu
                    mode="inline"
                    className={`${styles.customMenu} ${styles.userInfoMenu}`}
                    onSelect={handleMenu}
                    selectedKeys={location.pathname === '/billing' ? ['billing'] : (userOpen ? [siderNavigationStore.selectedMenu] : [])}
                >
                    <Menu.Item key="userInfo" className={`${styles.userInfoMenuItem} ${styles.userInfoFixedItem}`}>
                        <div className={styles.userInfoWrapper}>
                            <Popover
                                arrow={false}
                                trigger="click"
                                content={<UserInfoCard store={props.store} onClose={() => setUserOpen(false)} />}
                                placement="topRight"
                                classNames={{root: styles.userInfoPopover}}
                                open={userOpen}
                                onOpenChange={handleOpenChange}
                            >
                                <div className={styles.userInfo}>
                                    <div className={styles.userAvatar}>
                                        {userStore.userName ? (
                                            <div
                                                className={styles.avatarText}
                                                style={{fontSize: getAvatarFontSize(userStore.userName)}}
                                            >
                                                {getFirstChar(userStore.userName)}
                                            </div>
                                        ) : (
                                            <img src={userStore.logoPath || userImgPath} alt="avatar" />
                                        )}
                                    </div>
                                    <div className={styles.userAvatarName}>
                                        <div>{userStore.userName || 'username'}</div>
                                        <div className={styles.userInfoArrow}>
                                            {userStore.enterprisePlanText}
                                        </div>
                                    </div>
                                </div>
                            </Popover>
                        </div>
                    </Menu.Item>
                </Menu>
            </div>
        </>
    );
};

export default observer(Menus);
